<template>
    <div class="simple-flex-table">
        <ul v-if="head.length && data.length" class="simple-flex-table__list">
            <li class="simple-flex-table__head">
                <span
                    v-for="(h, index) in head"
                    :key="index"
                    class="simple-flex-table__data"
                    :style="{ 'flex-basis': basis(h) }"
                >
                    {{ headText(h) }}
                </span>
            </li>
            <li
                v-for="(item, index) in data"
                ref="items"
                :key="index"
                class="simple-flex-table__item"
            >
                <slot :item="item" />
            </li>
        </ul>
        <div v-else class="simple-flex-table__empty">
            <slot name="empty">No data</slot>
        </div>
    </div>
</template>
x

<script>
export default {
    name: 'SimpleTableList',
    props: {
        // array with head titles or { title, width }
        head: {
            type: Array,
            default: () => {},
        },
        data: {
            type: Array,
            default: () => {},
        },
    },

    computed: {
        baseFlexBasis() {
            return Math.floor(100 / this.head.length) + '%';
        },
    },

    watch: {
        data: {
            immediate: true,
            handler() {
                this.$nextTick(() => {
                    this.fixWidths();
                });
            },
        },
    },

    methods: {
        headText(heading) {
            return typeof heading === 'object' ? heading.text || '' : heading;
        },
        basis(heading) {
            return typeof heading === 'object'
                ? heading.width + '%' || this.baseFlexBasis
                : this.baseFlexBasis;
        },
        fixWidths() {
            const cells = this.$el.querySelectorAll('.simple-flex-table__item > *');
            cells.forEach((cell, index) => {
                const offset = Math.floor(index / this.head.length) * this.head.length;

                cell.style.flexBasis = this.basis(this.head[index - offset]);
            });
        },
    },
};
</script>

<style lang="scss" src="./SimpleFlexTable.scss"></style>
